export default "__VITE_ASSET__JvlQ2bP2__"